import { makeStyles, Paper, Table, TableBody, TableContainer } from '@material-ui/core';
import clsx from 'clsx';
import { ReactNode } from 'react';

import CarDetailHeadline from './CarDetailHeadline';

const useStyles = makeStyles((theme) => ({
  root: {
    '@media screen': {
      height: '100%',
    },
    '@media print': {
      overflow: 'visible !important',
      pageBreakInside: 'auto',
      breakInside: 'auto',
      '& table': {
        overflow: 'visible',
      },
      '& tr': {
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
        pageBreakAfter: 'auto',
        breakAfter: 'auto',
      },
    },
  },
  disableElevation: {
    borderRadius: 0,
  },
  headingBox: {
    padding: theme.spacing(2),
  },
  layoutFixed: {
    tableLayout: 'fixed',
  },
}));

type CarDetailTableProps = {
  title: string;
  children?: ReactNode;
  layoutFixed?: boolean;
  disableHeader?: boolean;
  disableElevation?: boolean;
  className?: string;
};

const CarDetailTable = ({
  title,
  children,
  layoutFixed,
  disableHeader = false,
  disableElevation = false,
  className,
}: CarDetailTableProps) => {
  const classes = useStyles();

  return (
    <TableContainer
      component={Paper}
      elevation={disableElevation ? 0 : 3}
      className={clsx(classes.root, disableElevation && classes.disableElevation, className)}
    >
      {!disableHeader && (
        <div className={classes.headingBox}>
          <CarDetailHeadline title={title} />
        </div>
      )}
      <Table size="small" className={layoutFixed ? classes.layoutFixed : ''}>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default CarDetailTable;
